import { RequestProvider } from '@/shared/providers/request.provider';
import { MYINFO_API, API_VARIABLES } from '../values/myinfo.values'
import { IUserInformation } from '@/tools/interfaces/userinformation-interface'

class MyInfoServicesClass {

  /* Get Methods */
  public async getPersonInformationById(personId: number): Promise<IUserInformation> {
      let url = MYINFO_API.GET_PERSONINFORMATION_BYID;
      url = url.replace(API_VARIABLES.PERSON_ID, personId.toString());
      return await RequestProvider.get(url);
  }

  public async updatePersonInformation(personId: number, userInformation:IUserInformation): Promise<void> {
    let url = MYINFO_API.UPDATE_PERSONINFORMATION
    url = url.replace(API_VARIABLES.PERSON_ID, personId.toString());
    await RequestProvider.put(url, userInformation);
  }

}

export const MyInfoServices = new MyInfoServicesClass();